var _path, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9525 13.1203C26.9647 13.2966 26.9647 13.4729 26.9647 13.6509C26.9647 19.0723 22.8371 25.325 15.2897 25.325V25.3217C13.0601 25.325 10.8769 24.6864 9 23.4823C9.32419 23.5213 9.65001 23.5408 9.97664 23.5416C11.8243 23.5433 13.6191 22.9234 15.0727 21.7819C13.3169 21.7486 11.7772 20.6038 11.2393 18.9326C11.8544 19.0512 12.4881 19.0268 13.0918 18.8619C11.1775 18.4752 9.80032 16.7934 9.80032 14.8403C9.80032 14.8224 9.80032 14.8054 9.80032 14.7883C10.3707 15.106 11.0093 15.2823 11.6626 15.3018C9.85964 14.0969 9.30388 11.6986 10.3926 9.82343C12.4759 12.3867 15.5497 13.945 18.8493 14.1099C18.5186 12.6849 18.9703 11.1916 20.0364 10.1898C21.689 8.63644 24.2882 8.71606 25.8418 10.3678C26.7607 10.1866 27.6415 9.84943 28.4475 9.37171C28.1412 10.3215 27.5001 11.1282 26.6437 11.6409C27.457 11.545 28.2517 11.3273 29 10.995C28.4491 11.8204 27.7552 12.5394 26.9525 13.1203Z",
    fill: "#1D9BF0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdii_1613_15476)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2.19995,
    width: 30,
    height: 30,
    rx: 8,
    fill: "white",
    fillOpacity: 0.530029
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1613_15476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9525 13.1203C26.9647 13.2966 26.9647 13.4729 26.9647 13.6509C26.9647 19.0723 22.8371 25.325 15.2897 25.325V25.3217C13.0601 25.325 10.8769 24.6864 9 23.4823C9.32419 23.5213 9.65001 23.5408 9.97664 23.5416C11.8243 23.5433 13.6191 22.9234 15.0727 21.7819C13.3169 21.7486 11.7772 20.6038 11.2393 18.9326C11.8544 19.0512 12.4881 19.0268 13.0918 18.8619C11.1775 18.4752 9.80032 16.7934 9.80032 14.8403C9.80032 14.8224 9.80032 14.8054 9.80032 14.7883C10.3707 15.106 11.0093 15.2823 11.6626 15.3018C9.85964 14.0969 9.30388 11.6986 10.3926 9.82343C12.4759 12.3867 15.5497 13.945 18.8493 14.1099C18.5186 12.6849 18.9703 11.1916 20.0364 10.1898C21.689 8.63644 24.2882 8.71606 25.8418 10.3678C26.7607 10.1866 27.6415 9.84943 28.4475 9.37171C28.1412 10.3215 27.5001 11.1282 26.6437 11.6409C27.457 11.545 28.2517 11.3273 29 10.995C28.4491 11.8204 27.7552 12.5394 26.9525 13.1203Z",
    fill: "#1D9BF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdii_1613_15476",
    x: -6.87313,
    y: -8.67318,
    width: 51.7463,
    height: 51.7463,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 5.43656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1613_15476"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1613_15476",
    result: "effect2_dropShadow_1613_15476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1613_15476",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1613_15476"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_1613_15476",
    result: "effect4_innerShadow_1613_15476"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1613_15476",
    x: 5,
    y: 3.07495,
    width: 28,
    height: 24.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1613_15476"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1613_15476",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f1322dc3f2dfc39d3c33ae93532d3233.svg";
export { ForwardRef as ReactComponent };